export default "__VITE_ASSET__8Sv_o6Q$__"